import BithidePaymentPay from './BithidePaymentPay';
export default BithidePaymentPay;
